import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"
import { slugify } from "helpers/fn_helper";

// Service
import {
    CreateContent,
    GetContentById,
    UpdateContent,
} from "./_services/Services.js"

import DatePicker from "react-datepicker"
import configWebRoute from "services/api/configWebRoute"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `region-link`
const _pageName = `Region Link`
const _parentComponent = configWebRoute.REGION_LINK
const _routePermission = `region-link`

const RegionLinkTemplate = ({
    pageName = "",
    pageView = "create",
    componentKey = "",
}) => {
    // POPUP
    const { mAlert } = useContext(ModalContext)

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? "TH"
    const qMainId = qParams?.id ?? null
    const navigate = useNavigate()

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)
    const [contentDetail, setContentDetail] = useState([])
    const [prefillComplete, setPrefillComplete] = useState()
    const [pageType, setPageType] = useState()
    const [waitCreatePreview, setWaitCreatePreview] = useState(false)

    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        linkLabel: Yup.string().required("Please Enter Link Label"),
        linkUrl: Yup.string().required("Please Enter Link URL"),

        updateDate: Yup.string().max(100).required("Please Select Written at"),
        mainStatus: Yup.string().max(100).required("Please Enter Display"),
    })

    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const initialValues = {
        // mainId: "",

        // ID
        linkLabel: "",
        linkUrl: "",
        updateDate: moment().format("YYYY-MM-DD"),
        mainStatus: "active",

        // Content

    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
            const payload = {
                id: qMainId ?? null,
                linkLabel: values?.linkLabel ?? null,
                linkUrl: values?.linkUrl ?? null,

                updateDate: values.updateDate,
                mainStatus: values.mainStatus,
            }

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContent(payload)
            }
            else {
                API.fetchCreateContent(payload)
            }
        },
    })

    const preFilInput = (resData = {}) => {
        // console.log("🚀 ~ preFilInput ~ resData:", resData)
        // resetForm(validation.values, initialValues)

        // ถ้าไม่หน่วงมันจะแย่งกันทำ
        validation.setFieldValue("linkLabel", resData?.linkLabel ?? "")
        validation.setFieldValue("linkUrl", resData?.linkUrl ?? "")
        validation.setFieldValue(
            "updateDate",
            resData?.updateDate ?? moment().format("YYYY-MM-DD")
        )
        validation.setFieldValue(
            "mainStatus",
            resData?.mainStatus ?? "active"
        )

        setContentDetail(resData)
        setPrefillComplete(true)
    }

    const API = {
        fetchGetContentById: async payload => {
            try {
                const response = await GetContentById({
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                    setPageType(resData.data.pageType)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload) => {
            try {
                const response = await CreateContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            navigate(`/${_routeLink}/edit/${resData.data.mainId}`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContent: async (payload) => {
            try {
                const response = await UpdateContent({
                    data: payload,
                    id: payload.id,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            // navigate(`/${_routeLink}/${qLang}/edit`)
                            window.location.reload()
                        },
                    })
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            const payload = { id: qMainId }
            setContentLoading(true)
            API.fetchGetContentById(payload)
        }
    }, [qLang])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: "10px",
        border: "1px solid black",
        margin: "5px",
        borderRadius: "8px",
        background: "#f9f9f9",
        transition: "transform 0.2s ease, background-color 0.3s ease",
    }

    const mapValues = (list = []) =>
        list.map(item => {
            const newObj = {
                attachmentId: item.attachmentId,
                sequence: item.sequence,
            }
            return newObj
        })

    // useEffect(() => {
    //     console.log('updatedValidationSchema >>> ', updatedValidationSchema)
    //     console.log('updatedValidationSchema Default >>> ', updatedValidationSchema.getDefault())
    // }, [updatedValidationSchema])
    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {contentLoading ? (
                        <Spinners setLoading={setContentLoading} />
                    ) : (
                        <Row>
                            <Col className="col-12">
                                <FormikProvider value={validation}>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={e => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >
                                        <Row>
                                            <Col className="col-8">
                                                <Row>
                                                    <Col className="col-12">
                                                        <Card>
                                                            <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                                <i className="bx bx-cube-alt"></i> {pageName}
                                                            </h5>
                                                            <CardBody>
                                                                <Row>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="linkLabel"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Link Label
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="linkLabel"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="linkLabel"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "linkLabel",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.linkLabel}
                                                                                invalid={
                                                                                    validation.touched.linkLabel &&
                                                                                        validation.errors.linkLabel
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.linkLabel &&
                                                                                validation.errors.linkLabel && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.linkLabel}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                    <Col className="col-12 mb-3">
                                                                        <label
                                                                            htmlFor="linkUrl"
                                                                            className="col-md-12 col-form-label"
                                                                        >
                                                                            Link URL
                                                                            <span className="t-require">*</span>
                                                                        </label>
                                                                        <div className="col-md-12">
                                                                            <Input
                                                                                id="linkUrl"
                                                                                className="form-control"
                                                                                type="text"
                                                                                placeholder=""
                                                                                name="linkUrl"
                                                                                onChange={e => {
                                                                                    validation.setFieldValue(
                                                                                        "linkUrl",
                                                                                        e.target.value
                                                                                    )
                                                                                }}
                                                                                onBlur={validation.handleBlur}
                                                                                value={validation.values.linkUrl}
                                                                                invalid={
                                                                                    validation.touched.linkUrl &&
                                                                                        validation.errors.linkUrl
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                disabled={pageView === "view"}
                                                                            />
                                                                            {validation.touched.linkUrl &&
                                                                                validation.errors.linkUrl && (
                                                                                    <FormFeedback type="invalid">
                                                                                        {validation.errors.linkUrl}
                                                                                    </FormFeedback>
                                                                                )}
                                                                        </div>
                                                                        <hr />
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col className="col-4">
                                                <Card
                                                    outline
                                                    color="primary"
                                                    className="border sticky-element"
                                                >
                                                    <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                        <i className="bx bx-check"></i> Tools Box
                                                    </h5>
                                                    <CardBody>
                                                        <Row>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="updateDate"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Written at
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <InputGroup>
                                                                        <Flatpickr
                                                                            className="form-control d-block"
                                                                            options={{
                                                                                dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                            }}
                                                                            value={
                                                                                validation.values.updateDate
                                                                                    ? moment(
                                                                                        validation.values
                                                                                            .updateDate,
                                                                                        "YYYY-MM-DD"
                                                                                    ).toDate()
                                                                                    : null
                                                                            }
                                                                            disabled={true}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                disabled
                                                                            >
                                                                                <i
                                                                                    className="fa fa-calendar"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </InputGroup>
                                                                    {validation.touched.updateDate &&
                                                                        validation.errors.updateDate && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.updateDate}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                            <Col className="col-12 mb-3">
                                                                <label
                                                                    htmlFor="mainStatus"
                                                                    className="col-md-12 col-form-label"
                                                                >
                                                                    Display
                                                                    <span className="t-require">*</span>
                                                                </label>
                                                                <div className="col-md-12">
                                                                    <Select
                                                                        placeholder="Select Status"
                                                                        value={fn_helper.FNFORM.getObjectValue(
                                                                            STATUS_OPTION,
                                                                            `${validation.values.mainStatus}`
                                                                        )}
                                                                        onChange={value =>
                                                                            validation.setFieldValue(
                                                                                "mainStatus",
                                                                                value.id
                                                                            )
                                                                        }
                                                                        getOptionValue={option => option.id}
                                                                        getOptionLabel={option => option.name}
                                                                        options={STATUS_OPTION}
                                                                        className={`select2-selection ${validation.touched.mainStatus &&
                                                                            validation.errors.mainStatus
                                                                            ? "input-err"
                                                                            : ""
                                                                            }`}
                                                                        isDisabled={pageView === "view"}
                                                                    />
                                                                    {validation.touched.mainStatus &&
                                                                        validation.errors.mainStatus && (
                                                                            <div
                                                                                type="invalid"
                                                                                className="invalid-feedback d-block"
                                                                            >
                                                                                {validation.errors.mainStatus}
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                    <CardFooter>
                                                        <Row>
                                                            <Col className="text-start">
                                                                <Button
                                                                    color="danger"
                                                                    className="btn btn-danger"
                                                                    onClick={() =>
                                                                        navigate(`/${_routeLink}`)
                                                                    }
                                                                >
                                                                    Back
                                                                </Button>
                                                            </Col>
                                                            <Col className="text-end">
                                                                {pageType == 'page' &&
                                                                    <>
                                                                        <Button
                                                                            className="btn btn-block btn-primary"
                                                                            onClick={handlePreview}
                                                                        >
                                                                            Preview{" "}
                                                                            {waitCreatePreview ? (
                                                                                <Spinner size="sm" color="light" />
                                                                            ) : null}
                                                                        </Button>
                                                                        &nbsp;
                                                                    </>
                                                                }
                                                                {pageView !== "view" && (
                                                                    <Button
                                                                        type="submit"
                                                                        className="btn btn-success"
                                                                    >
                                                                        Save{" "}
                                                                        {waitSendData ? (
                                                                            <Spinner size="sm" color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                )}
                                                            </Col>
                                                        </Row>
                                                    </CardFooter>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Form>
                                </FormikProvider>
                            </Col>
                        </Row>
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

// RegionLinkTemplate.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(RegionLinkTemplate)
